import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=5c98648d&scoped=true&"
import script from "./LockIcon.vue?vue&type=script&lang=js&"
export * from "./LockIcon.vue?vue&type=script&lang=js&"
import style0 from "./LockIcon.vue?vue&type=style&index=0&id=5c98648d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98648d",
  null
  
)

export default component.exports